<template>
    <div>
        <h1>CONTOH</h1>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>